import { STRATEGIES_ENDPOINT } from "../constants/settings";
import { myFetch } from "../helpers/myFetch";

export const getMostBuyStrategies = () => {
  return myFetch(`${STRATEGIES_ENDPOINT}/popular/buy`, "GET");
};
